import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useUser } from "../Contexts/UserContext";
import { Button, CircularProgress, Box, ButtonGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";

// Register the necessary components with Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

const BasicBars2 = () => {
  const [chartData, setChartData] = useState(null);
  const [view, setView] = useState("month"); // default view
  const { user } = useUser();
  const { ClientId, CompCode } = user;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_URL}/facility/GetWashRoomGraphData/1/${CompCode}/${ClientId}/unitCode`
        ).then((res) => res.json());

        if (response.success) {
          const structuredData = structureData(response.data);
          setChartData(structuredData);
        } else {
          alert(response.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [view]);

  const structureData = (data) => {
    const labels = [];
    const scores = [];

    data.forEach((element) => {
      labels.push(element.Lable);
      scores.push(element.Score);
    });

    return {
      labels: labels,
      datasets: [
        {
          label: `Cleaning`,
          data: scores,
          backgroundColor: "green",
          borderColor: "green",
          borderWidth: 1,
        },
      ],
    };
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Washroom Checklist",
      },
    },
    scales: {
      x: {
        stacked: false,
      },
      y: {
        stacked: false,
        beginAtZero: true,
      },
    },
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const ChartContainer = styled(Box)({
    width: "100%",
    height: "280px",
    display: "flex",
    flexDirection: "row", // Align items horizontally
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "26px",
  });

  const StyledButton = styled(Button)({
    minWidth: "20px",
    height: "20px",
    backgroundColor: "#eee",
    color: "#000",
    borderRadius: "50%",
    padding: "0",
    margin: "4px 0",
    fontSize: "10px",
    lineHeight: "20px",
  });

  if (!chartData) {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ChartContainer>
      {/* <ButtonGroup
        orientation="vertical"
        variant="contained"
        sx={{ padding: 0 }}
      >
        <StyledButton onClick={() => setView("1")}>•</StyledButton>
        <StyledButton onClick={() => setView("2")}>•</StyledButton>
        <StyledButton onClick={() => setView("3")}>•</StyledButton>
      </ButtonGroup> */}
      <Bar data={chartData} options={options} />
    </ChartContainer>
  );
};

export default BasicBars2;
